/** Role whose pool is configured in the module seat settings panel. */
export type ModuleFilterRole = 'TRAINED' | 'SHADOW' | 'REVERSE_SHADOW';

/** People vs attributes source for a single role filter. */
export const SOURCE_MODE = {
  PEOPLE: 'PEOPLE',
  ATTRIBUTES: 'ATTRIBUTES',
} as const;

export type SourceMode = (typeof SOURCE_MODE)[keyof typeof SOURCE_MODE];
